<template>

<section id="levelSection" class="level-section">

    <v-container class="main-container">

        <!-- ========================= -->
        <!-- LEVELS -->
        <!-- ========================= -->

        <section class="levels-section">

            <div class="level-header">

                <span class="section-chip">
                    EXPLORE
                </span>

                <h2>
                    Explore your level
                </h2>

            </div>


            <div class="level-grid">

                <div
                    v-for="level in levels"
                    :key="level.slug"
                    class="level-card"
                    @click="goToLevel(level.slug)"
                >

                    <img
                        :src="getStorageUrl(level.image)"
                        :alt="level.title"
                    >

                    <div class="level-overlay"></div>

                    <div class="level-info">

                        <h3>
                            {{ level.title }}
                        </h3>

                    </div>

                </div>

            </div>

        </section>


        <!-- ===================== -->
        <!-- POPULAR -->
        <!-- ===================== -->

        <section class="popular-section">

            <div class="section-header">

                <div>

                    <span class="section-chip">
                        DISCOVER
                    </span>

                    <h2>
                        Popular
                    </h2>

                </div>

                <a
                    href="#"
                    class="see-all"
                    @click.prevent
                >
                    See all →
                </a>

            </div>


            <div class="carousel">

                <button
                    class="arrow left"
                    @click="scrollLeft"
                >
                    ❮
                </button>


                <div
                    ref="slider"
                    class="carousel-track"
                >

                    <div
                        v-for="trick in popularTricks"
                        :key="trick.slug"
                        class="movie-card"
                        @click="goToTrick(trick)"
                    >

                        <img
                            :src="getPopularImage(trick)"
                            :alt="trick.title"
                        >

                        <span>
                            {{ trick.title }}
                        </span>

                    </div>

                </div>


                <button
                    class="arrow right"
                    @click="scrollRight"
                >
                    ❯
                </button>

            </div>

        </section>

    </v-container>

</section>

</template>


<script>

import { urlBase } from "@/service/Api";

export default {

    name: "LevelSection",

    data() {

        return {

            levels: [
                {
                    title: "Beginner",
                    slug: "beginner",
                    image: "level/beginner.jpg"
                },
                {
                    title: "Intermediate",
                    slug: "intermediate",
                    image: "level/intermediate.jpg"
                },
                {
                    title: "Advanced",
                    slug: "advanced",
                    image: "level/advanced.jpg"
                },
                {
                    title: "Expert",
                    slug: "expert",
                    image: "level/expert.jpg"
                }
            ],


            /*
             * =========================
             * POPULAR
             * =========================
             *
             * Por ahora elegidos manualmente.
             *
             * Si después querés agregar más,
             * solamente agregamos objetos acá.
             */

            popularTricks: [

                {
                    title: "Butterfly",
                    slug: "butterfly"
                },

                {
                    title: "Aisha",
                    slug: "aisha"
                },

                {
                    title: "Iron X",
                    slug: "iron-x"
                },

                {
                    title: "Jade",
                    slug: "jade"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

                {
                    title: "Around the World",
                    slug: "around-the-world"
                },

            ]

        };

    },


    methods: {

        /*
         * =========================
         * STORAGE
         * =========================
         */

        getStorageUrl(path) {

            const backendUrl = urlBase.replace(
                /\/api\/?$/,
                ""
            );

            return `${backendUrl}/storage/${path}`;

        },


        /*
         * =========================
         * IMAGEN POPULAR
         * =========================
         *
         * Las portadas de los trucos ya
         * siguen esta estructura:
         *
         * trucos/{slug}/portada/portada.jpg
         */

        getPopularImage(trick) {

            return this.getStorageUrl(
                `trucos/${trick.slug}/portada/portada.jpg`
            );

        },


        /*
         * =========================
         * IR AL LEVEL
         * =========================
         */

        goToLevel(slug) {

            this.$router.push({
                name: "level",
                params: {
                    level: slug
                }
            });

        },


        /*
         * =========================
         * IR AL TRUCO
         * =========================
         */

        goToTrick(trick) {

            if (
                !trick ||
                !trick.slug
            ) {
                return;
            }

            this.$router.push(
                `/trick/${trick.slug}`
            );

        },


        /*
         * =========================
         * CAROUSEL
         * =========================
         */

        scrollLeft() {

            this.$refs.slider.scrollBy({
                left: -700,
                behavior: "smooth"
            });

        },


        scrollRight() {

            this.$refs.slider.scrollBy({
                left: 700,
                behavior: "smooth"
            });

        }

    }

};

</script>


<style scoped>

.level-section{

    background:#111;

    min-height:100svh;

    /* padding:2rem; */

}


.main-container {

    height: 100%;

    display: flex;

    flex-direction: column;

    padding-top: 28px;

    padding-bottom: 24px;

}


/* ================================================= */
/* HEADERS */
/* ================================================= */

.level-header {

    margin-bottom: 14px;

}


.section-header {

    display: flex;

    justify-content: space-between;

    align-items: flex-end;

    margin-bottom: 12px;

}


.section-chip {

    display: block;

    margin-top: 2rem;
    margin-bottom: 3px;

    color: #8DB8FF;

    font-size: .68rem;

    font-weight: 700;

    letter-spacing: .1em;

}


.level-header h2,
.section-header h2 {

    margin: 0;

    color: white;

    font-size: clamp(1.5rem, 2vw, 2rem);

    line-height: 1.1;

    font-weight: 800;

}


.see-all {

    color: #8DB8FF;

    text-decoration: none;

    font-size: .85rem;

    font-weight: 600;

    transition: .25s;

}


.see-all:hover {

    color: white;

}


/* ================================================= */
/* LEVELS */
/* ================================================= */

.levels-section {

    flex: 0 0 auto;

}


.level-grid {

    display: grid;

    grid-template-columns: repeat(4, minmax(0, 1fr));

    gap: 14px;

}


.level-card {

    position: relative;

    height: clamp(150px, 21vh, 205px);

    overflow: hidden;

    border-radius: 16px;

    cursor: pointer;

    background: #181818;

    transition:
        transform .25s,
        box-shadow .25s;

}


.level-card:hover {

    transform: translateY(-4px);

    box-shadow: 0 15px 35px rgba(0, 0, 0, .35);

}


.level-card img {

    width: 100%;

    height: 100%;

    display: block;

    object-fit: cover;

    transition: transform .4s;

}


.level-card:hover img {

    transform: scale(1.04);

}


.level-overlay {

    position: absolute;

    inset: 0;

    background: linear-gradient(
        to top,
        rgba(0, 0, 0, .85) 0%,
        rgba(0, 0, 0, .20) 55%,
        transparent 100%
    );

}


.level-info {

    position: absolute;

    left: 0;

    right: 0;

    bottom: 0;

    padding: 14px;

}


.level-info h3 {

    margin: 0;

    color: white;

    font-size: 1rem;

    font-weight: 700;

    text-align: center;

}


/* ================================================= */
/* POPULARES */
/* ================================================= */

.popular-section {

    flex: 1;

    min-height: 0;

    display: flex;

    flex-direction: column;

    padding-top: 24px;

}


/* ================================================= */
/* CAROUSEL */
/* ================================================= */

.carousel {

    position: relative;

    flex: 1;

    min-height: 0;

    display: flex;

    align-items: center;

}


.carousel-track {

    width: 100%;

    height: 100%;

    display: flex;

    align-items: flex-start;

    gap: 14px;

    overflow-x: auto;

    overflow-y: hidden;

    scroll-behavior: smooth;

    scroll-snap-type: x proximity;

    padding: 4px;

    scrollbar-width: none;

    -ms-overflow-style: none;

}


.carousel-track::-webkit-scrollbar {

    display: none;

}


/* ================================================= */
/* POPULAR CARD */
/* ================================================= */

.movie-card {

    flex: 0 0 clamp(105px, 9.5vw, 145px);

    min-width: 0;

    scroll-snap-align: start;

    cursor: pointer;

    transition: transform .25s;

}


.movie-card:hover {

    transform: translateY(-3px);

}


.movie-card img {

    width: 100%;

    height: clamp(145px, 20vh, 205px);

    display: block;

    object-fit: cover;

    border-radius: 12px;

    box-shadow: 0 8px 20px rgba(0, 0, 0, .3);

}


.movie-card span {

    display: block;

    margin-top: 5px;

    overflow: hidden;

    color: white;

    font-size: .75rem;

    font-weight: 600;

    text-align: center;

    white-space: nowrap;

    text-overflow: ellipsis;

}


/* ================================================= */
/* FLECHAS */
/* ================================================= */

.arrow {

    position: absolute;

    top: 45%;

    transform: translateY(-50%);

    width: 38px;

    height: 38px;

    padding: 0;

    border: none;

    border-radius: 50%;

    background: rgba(0, 0, 0, .68);

    color: white;

    cursor: pointer;

    z-index: 20;

    transition: .2s;

}


.arrow:hover {

    background: black;

}


.left {

    left: -18px;

}


.right {

    right: -18px;

}


/* ================================================= */
/* PANTALLAS BAJAS DE DESKTOP */
/* ================================================= */

@media (min-width: 601px) and (max-height: 760px) {

    .main-container {

        padding-top: 18px;

        padding-bottom: 14px;

    }


    .level-header {

        margin-bottom: 8px;

    }


    .level-card {

        height: 140px;

    }


    .popular-section {

        padding-top: 15px;

    }


    .section-header {

        margin-bottom: 8px;

    }


    .movie-card img {

        height: 150px;

    }

}


/* ================================================= */
/* MOBILE */
/* ================================================= */

@media(max-width: 600px) {

    .level-section {

        height: auto;

        min-height: 100svh;

        overflow: visible;

    }


    .main-container {

        height: auto;

        /* padding:
            24px
            14px
            30px; */

    }


    /* LEVELS 2 x 2 */

    .level-grid {

        grid-template-columns:
            repeat(2, minmax(0, 1fr));

        gap: 10px;

    }


    .level-card {

        height: 145px;

        border-radius: 12px;

    }


    .level-info {

        padding: 10px;

    }


    .level-info h3 {

        font-size: .9rem;

    }


    /* POPULARES */

    .popular-section {

        padding-top: 28px;

    }


    .section-header {

        margin-bottom: 12px;

    }


    .level-header h2,
    .section-header h2 {

        font-size: 1.45rem;

    }


    .movie-card {

        flex: 0 0 125px;

    }


    .movie-card img {

        height: 175px;

    }


    .movie-card span {

        font-size: .72rem;

    }


    .arrow {

        display: none;

    }

}

</style>